import type { Lens } from '@hookform/lenses';
import { z } from 'zod/v4';
import OrdersIcon from '@interxfi/design-system/icons/react/icon-orders';
import type { IxcOrdersV1BatchOrderControls } from '@interxfi/types/generated/api';
import { AccordionFormGroup } from '../../../../../../components/card-group/form/accordion-form-group';
import { AppSwitchInputWithLens } from '../../../../../../components/form/app-switch-input';

export const programControlsBatchOrderFormSchema = z.object({
  canPlaceBatchOrders: z.boolean(),
});

export type ProgramControlsBatchOrderFormValues = z.infer<typeof programControlsBatchOrderFormSchema>;

export const programControlsBatchOrderFormDefaultValues: ProgramControlsBatchOrderFormValues = {
  canPlaceBatchOrders: false,
};

export function getInitialFormValuesForProgramBatchOrderControls(
  data: IxcOrdersV1BatchOrderControls | undefined,
): ProgramControlsBatchOrderFormValues {
  if (!data) {
    return programControlsBatchOrderFormDefaultValues;
  }

  return {
    canPlaceBatchOrders: Boolean(data.settings?.usEquities?.canPlaceBatchOrders),
  };
}

export function formValuesToProgramBatchOrderControls(values: ProgramControlsBatchOrderFormValues): IxcOrdersV1BatchOrderControls {
  return {
    settings: {
      usEquities: {
        canPlaceBatchOrders: values.canPlaceBatchOrders,
      },
    },
  };
}

interface ProgramBatchOrderControlsFormProps {
  lens: Lens<ProgramControlsBatchOrderFormValues>;
}

export function ProgramBatchOrderControlsForm({ lens }: ProgramBatchOrderControlsFormProps) {
  return (
    <AccordionFormGroup icon={<OrdersIcon aria-hidden />} title="Batch Orders">
      <AccordionFormGroup.Section
        toggleInputElement={<AppSwitchInputWithLens align="space-between" label="Place Batch Orders" lens={lens.focus('canPlaceBatchOrders')} />}
      />
    </AccordionFormGroup>
  );
}
